import {Dropdown, Menu} from "antd";
import {EllipsisOutlined} from "@ant-design/icons";
import classnames from "classnames";
import {DeliveryProviderDeliveryStatus} from "../../dashboards/DeliveryProviderDashboard/DeliveryProviderDeliveries/consts";

export const imageProps = {
    width: 350,
    height: 120
};

export const getPanelKeyByStatus = status => {
    switch (status) {
        case DeliveryProviderDeliveryStatus.arrivedAtBusiness:
            return "2";
        case DeliveryProviderDeliveryStatus.pickedUp:
            return "3";
        case DeliveryProviderDeliveryStatus.onTheWay:
            return "4";
        case DeliveryProviderDeliveryStatus.arrivedAtDestination:
            return "5";
        default:
            return "1";
    }
};

export const collapseKeyToStatus = {
    1: [
        DeliveryProviderDeliveryStatus.pending,
        DeliveryProviderDeliveryStatus.arrivedAtBusiness,
        DeliveryProviderDeliveryStatus.pickedUp,
        DeliveryProviderDeliveryStatus.onTheWay,
        DeliveryProviderDeliveryStatus.arrivedAtDestination,
        DeliveryProviderDeliveryStatus.supplied,
        DeliveryProviderDeliveryStatus.failed
    ],
    2: [
        DeliveryProviderDeliveryStatus.arrivedAtBusiness,
        DeliveryProviderDeliveryStatus.pickedUp,
        DeliveryProviderDeliveryStatus.onTheWay,
        DeliveryProviderDeliveryStatus.arrivedAtDestination,
        DeliveryProviderDeliveryStatus.supplied,
        DeliveryProviderDeliveryStatus.failed
    ],
    3: [
        DeliveryProviderDeliveryStatus.pickedUp,
        DeliveryProviderDeliveryStatus.onTheWay,
        DeliveryProviderDeliveryStatus.arrivedAtDestination,
        DeliveryProviderDeliveryStatus.supplied,
        DeliveryProviderDeliveryStatus.failed
    ],
    4: [
        DeliveryProviderDeliveryStatus.onTheWay,
        DeliveryProviderDeliveryStatus.arrivedAtDestination,
        DeliveryProviderDeliveryStatus.supplied,
        DeliveryProviderDeliveryStatus.failed
    ],
    5: [
        DeliveryProviderDeliveryStatus.arrivedAtDestination,
        DeliveryProviderDeliveryStatus.supplied,
        DeliveryProviderDeliveryStatus.failed
    ]
};

export const collapseKeyToStatusForDisabled = {
    1: [DeliveryProviderDeliveryStatus.pending],
    2: [DeliveryProviderDeliveryStatus.arrivedAtBusiness],
    3: [DeliveryProviderDeliveryStatus.pickedUp],
    4: [DeliveryProviderDeliveryStatus.onTheWay],
    5: [DeliveryProviderDeliveryStatus.arrivedAtDestination]
};

export const statusHistoryPriorityByCollapseKey = {
    1: [DeliveryProviderDeliveryStatus.arrivedAtBusiness],
    2: [DeliveryProviderDeliveryStatus.pickedUp],
    3: [DeliveryProviderDeliveryStatus.onTheWay],
    4: [DeliveryProviderDeliveryStatus.arrivedAtDestination],
    5: [DeliveryProviderDeliveryStatus.supplied]
};

export const menuActionLabelByKey = {
    delay: "איחור בהגעה לבית העסק",
    pickUpDelay: "ההזמנה לא מוכנה לאיסוף בזמן",
    supplyDelay: "מאחר במסירת המשלוח",
    supplyError: "לא ניתן להשאיר ביעד",
    missingItemsDelivery: "חסרים פריטים במשלוח"
};

export const statusHistoryToText = {
    [DeliveryProviderDeliveryStatus.arrivedAtBusiness]: "הגעתי לבית העסק",
    [DeliveryProviderDeliveryStatus.pickedUp]: "אספתי את המשלוח",
    [DeliveryProviderDeliveryStatus.onTheWay]: "התחל נסיעה",
    [DeliveryProviderDeliveryStatus.arrivedAtDestination]: "אישור מסירת המשלוח",
    [DeliveryProviderDeliveryStatus.supplied]: "מסרתי את המשלוח"
};

export const getActionsByCollapseKey = (
    collapseKey,
    onClick,
    loading,
    {onMenuAction, status, disabled = false} = {}
) => {
    const isDisabled = disabled || !collapseKeyToStatusForDisabled[collapseKey].includes(status);

    switch (collapseKey) {
        case "1":
            return [
                {
                    text: "הגעתי לבית העסק",
                    onClick: () => {
                        if (onClick) onClick();
                    },
                    className: "delivery-button delivery-arrived-button",
                    disabled: isDisabled,
                    loading: loading
                },
                {
                    type: "custom",
                    customComponent: (
                        <Dropdown
                            overlay={
                                <Menu
                                    items={[
                                        {
                                            key: "delay",
                                            label: menuActionLabelByKey.delay
                                        }
                                    ]}
                                    onClick={({key}) => {
                                        const labelText = menuActionLabelByKey[key] ?? key;
                                        if (onMenuAction) onMenuAction(key, labelText);
                                    }}
                                />
                            }
                            trigger={["click"]}
                            disabled={false}>
                            <div className={classnames("delivery-menu-button")}>
                                <EllipsisOutlined style={{fontSize: 25}} />
                            </div>
                        </Dropdown>
                    )
                }
            ];
        case "2":
            return [
                {
                    text: "אספתי את המשלוח",
                    onClick: () => {
                        if (onClick) onClick();
                    },
                    className: "delivery-button delivery-picked-up-button",
                    disabled: isDisabled,
                    loading: loading
                },
                {
                    type: "custom",
                    customComponent: (
                        <Dropdown
                            overlay={
                                <Menu
                                    items={[
                                        {
                                            key: "pickUpDelay",
                                            label: menuActionLabelByKey.pickUpDelay
                                        }
                                    ]}
                                    onClick={({key}) => {
                                        const labelText = menuActionLabelByKey[key] ?? key;
                                        if (onMenuAction) onMenuAction(key, labelText);
                                    }}
                                />
                            }
                            trigger={["click"]}
                            disabled={false}>
                            <div className={classnames("delivery-menu-button")}>
                                <EllipsisOutlined style={{fontSize: 25}} />
                            </div>
                        </Dropdown>
                    )
                }
            ];
        case "3":
            return [
                {
                    text: "התחל נסיעה",
                    onClick: () => {
                        if (onClick) onClick();
                    },
                    className: "delivery-button delivery-navigated-button",
                    disabled: isDisabled,
                    loading: loading
                }
            ];
        case "4":
            return [
                {
                    text: "אישור מסירת המשלוח",
                    onClick: () => {
                        if (onClick) onClick();
                    },
                    className: "delivery-button delivery-supplied-button",
                    disabled: isDisabled,
                    loading: loading
                },
                {
                    type: "custom",
                    customComponent: (
                        <Dropdown
                            overlay={
                                <Menu
                                    items={[
                                        {
                                            key: "supplyDelay",
                                            label: menuActionLabelByKey.supplyDelay
                                        },
                                        {
                                            key: "supplyError",
                                            label: menuActionLabelByKey.supplyError
                                        }
                                    ]}
                                    onClick={({key}) => {
                                        const labelText = menuActionLabelByKey[key] ?? key;
                                        if (onMenuAction) onMenuAction(key, labelText);
                                    }}
                                />
                            }
                            trigger={["click"]}
                            disabled={false}>
                            <div className={classnames("delivery-menu-button")}>
                                <EllipsisOutlined style={{fontSize: 25}} />
                            </div>
                        </Dropdown>
                    )
                }
            ];
        case "5":
            return [
                {
                    text: "מסרתי את המשלוח",
                    onClick: () => {
                        if (onClick) onClick();
                    },
                    className: "delivery-button delivery-supplied-button",
                    disabled: isDisabled,
                    loading: loading
                },
                {
                    type: "custom",
                    customComponent: (
                        <Dropdown
                            overlay={
                                <Menu
                                    items={[
                                        {
                                            key: "missingItemsDelivery",
                                            label: menuActionLabelByKey.missingItemsDelivery
                                        }
                                    ]}
                                    onClick={({key}) => {
                                        const labelText = menuActionLabelByKey[key] ?? key;
                                        if (onMenuAction) onMenuAction(key, labelText);
                                    }}
                                />
                            }
                            trigger={["click"]}
                            disabled={false}>
                            <div className={classnames("delivery-menu-button")}>
                                <EllipsisOutlined style={{fontSize: 25}} />
                            </div>
                        </Dropdown>
                    )
                }
            ];
        default:
            return [];
    }
};

export const getCoordinates = location => {
    const lat =
        location?.lat ??
        location?.latitude ??
        location?.geo?.lat ??
        location?.geo?.latitude ??
        location?.geometry?.location?.lat;
    const lng =
        location?.lng ??
        location?.lon ??
        location?.longitude ??
        location?.geo?.lng ??
        location?.geo?.longitude ??
        location?.geometry?.location?.lng;

    if (typeof lat === "number" && typeof lng === "number") {
        return {lat, lng};
    }

    if (typeof lat === "string" && typeof lng === "string") {
        return {lat: Number(lat), lng: Number(lng)};
    }

    return null;
};

export const buildWazeUrl = location => {
    const coordinates = getCoordinates(location);
    if (coordinates) {
        return `https://waze.com/ul?ll=${coordinates.lat},${coordinates.lng}&navigate=yes`;
    }

    const address = location?.address || location?.formattedAddress || location;
    if (!address) {
        return null;
    }
    return `https://waze.com/ul?q=${encodeURIComponent(address)}&navigate=yes`;
};

export const buildGoogleMapsUrl = location => {
    const coordinates = getCoordinates(location);
    if (coordinates) {
        return `https://www.google.com/maps/dir/?api=1&destination=${coordinates.lat},${coordinates.lng}`;
    }

    const placeId = location?.place_id || location?.placeId;
    if (placeId) {
        return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
            placeId
        )}&destination_place_id=${encodeURIComponent(placeId)}`;
    }

    const address = location?.address || location?.formattedAddress || location;
    if (!address) {
        return null;
    }
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
};
